import React from "react";
import {
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Space,
} from "antd";
import {
  CalendarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const SupplierInformation = ({
  suppliers = [],
  isMobile,
}) => {
  return (
    <Card
      title={
        <Space>
          <FileTextOutlined />
          <span>Order Information</span>
        </Space>
      }
      style={{
        borderRadius: 14,
        marginBottom: 20,
      }}
    >
      <Row gutter={[20, 4]}>
        <Col xs={24} md={8}>
          <Form.Item
            name="supplierId"
            label="Supplier"
            rules={[
              {
                required: true,
                message: "Please select a supplier",
              },
            ]}
          >
            <Select
              showSearch
              size="large"
              placeholder="Select supplier"
              optionFilterProp="label"
              options={suppliers.map((supplier) => ({
                value: supplier.id,
                label: `${supplier.name} (${supplier.country || "N/A"})`,
              }))}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            name="orderDate"
            label="Order Date"
            rules={[
              {
                required: true,
                message: "Please select order date",
              },
            ]}
          >
            <DatePicker
              size="large"
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              suffixIcon={<CalendarOutlined />}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={8}>
          <Form.Item
            name="currency"
            label="Currency"
          >
            <Select
              size="large"
              options={[
                {
                  value: "USD",
                  label: "USD - US Dollar",
                },
                {
                  value: "EUR",
                  label: "EUR - Euro",
                },
                {
                  value: "CNY",
                  label: "CNY - Chinese Yuan",
                },
                {
                  value: "ETB",
                  label: "ETB - Ethiopian Birr",
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default SupplierInformation;